import { OwnershipProperty } from "src/components";
import { TaskItemDetailDto, useEditTaskItemOwners, UserDto } from "src/http";

interface IProps {
  taskItem: TaskItemDetailDto;
  onChanged?: (taskItemGuid: string, taskItemDescription: string, removedOwners: UserDto[]) => void;
}

const TaskItemOwnershipProperty = (props: IProps) => {
  const { mutate: editOwners } = useEditTaskItemOwners();

  function handleSaveClicked(updatedOwners: UserDto[], removedOwners: UserDto[], primaryOwner: UserDto | null) {
    editOwners(
      {
        taskItemGuid: props.taskItem.guid,
        teamSlug: props.taskItem.team?.slug,
        owners: updatedOwners,
        primaryOwner: primaryOwner,
      },
      {
        onSuccess: () => {
          props.onChanged?.(props.taskItem.guid, props.taskItem.description, removedOwners);
        },
      }
    );
  }

  return (
    <OwnershipProperty
      owners={props.taskItem.owners.map((x) => x.user)}
      primaryOwner={props.taskItem.primaryOwner}
      userCanEdit={props.taskItem.userCanEdit}
      onSaveClicked={handleSaveClicked}
    />
  );
};

export { TaskItemOwnershipProperty };
